(function () {
  var root = document.querySelector('[data-visible-filter]');
  if (!root) return;

  var grid = document.getElementById('product-grid');
  var pager = document.getElementById('product-pagination');
  var container = document.getElementById('ProductGridContainer');
  if (!grid) return;

  var sectionId = root.getAttribute('data-section-id');
  var basePath = (root.getAttribute('data-collection-url') || window.location.pathname).replace(/\/+$/, '');
  var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 16;

  var allCards = [];
  var index = [];
  var viewCards = [];
  var filtersActive = false;

  // ---- Collection map (product handle -> [collection handles]) + labels ----
  var collLabels = {};
  var handleToCollections = {};
  (function loadMap() {
    var el = document.getElementById('cvf-collection-map');
    if (!el) return;
    try {
      var data = JSON.parse(el.textContent);
      collLabels = data.labels || {};
      var raw = data.map || {};
      // raw may be { productHandle: collHandle } (one entry per membership).
      // Because a JSON object can't hold duplicate keys, we also accept arrays.
      Object.keys(raw).forEach(function (ph) {
        var v = raw[ph];
        if (!handleToCollections[ph]) handleToCollections[ph] = [];
        if (Array.isArray(v)) {
          v.forEach(function (c) { if (handleToCollections[ph].indexOf(c) === -1) handleToCollections[ph].push(c); });
        } else if (handleToCollections[ph].indexOf(v) === -1) {
          handleToCollections[ph].push(v);
        }
      });
    } catch (e) {
      console.error('[cvf] collection map parse failed', e);
    }
  })();

  function showLoader() { if (container) container.classList.add('is-loading'); }
  function hideLoader() { if (container) container.classList.remove('is-loading'); }

  function getPageFromPath() {
    var re = new RegExp(basePath.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '/(\\d+)$');
    var m = window.location.pathname.match(re);
    if (m) return parseInt(m[1], 10);
    var q = new URLSearchParams(window.location.search).get('page');
    return q ? parseInt(q, 10) : 1;
  }

  function pageUrl(n) { return n <= 1 ? basePath : basePath + '/' + n; }

  function productHandleFromHtml(html) {
    var m = html.match(/\/products\/([a-z0-9\-]+)/i);
    return m ? m[1] : '';
  }

  function parseCard(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var li = doc.body.firstElementChild;
    var text = (li.textContent || '').toLowerCase();

    var vendorEl = li.querySelector('.product-vendor, .caption-with-letter-spacing, .card__caption');
    var vendor = vendorEl ? vendorEl.textContent.trim() : '';

    var titleEl = li.querySelector('.card__heading a, .card__heading, .full-unstyled-link');
    var title = titleEl ? titleEl.textContent.trim() : '';

    var priceEl = li.querySelector('.price-item--regular, .price-item, .price');
    var price = 0;
    if (priceEl) { price = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0; }

    var handle = productHandleFromHtml(html);
    var collections = handleToCollections[handle] || [];

    return { html: html, title: title, vendor: vendor, price: price, text: text, collections: collections };
  }

  function buildIndex() { index = allCards.map(parseCard); }

  function renderPager(current, totalPages) {
    if (!pager) return;
    if (totalPages <= 1) { pager.innerHTML = ''; return; }
    var html = '<nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';
    if (current > 1) html += '<li><a class="pagination__item pagination__item--prev link" data-page="' + (current - 1) + '" href="' + pageUrl(current - 1) + '">&laquo;</a></li>';
    for (var i = 1; i <= totalPages; i++) {
      if (i === current) html += '<li><span class="pagination__item pagination__item--current" aria-current="page">' + i + '</span></li>';
      else html += '<li><a class="pagination__item link" data-page="' + i + '" href="' + pageUrl(i) + '">' + i + '</a></li>';
    }
    if (current < totalPages) html += '<li><a class="pagination__item pagination__item--next link" data-page="' + (current + 1) + '" href="' + pageUrl(current + 1) + '">&raquo;</a></li>';
    html += '</ul></nav>';
    pager.innerHTML = html;

    pager.querySelectorAll('a[data-page]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var n = parseInt(a.getAttribute('data-page'), 10);
        if (!filtersActive) { history.pushState({ page: n }, '', pageUrl(n)); }
        paint(n);
        window.scrollTo({ top: grid.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
      });
    });
  }

  function paint(page) {
    var totalPages = Math.max(1, Math.ceil(viewCards.length / perPage));
    var current = Math.min(Math.max(1, page || (filtersActive ? 1 : getPageFromPath())), totalPages);
    var start = (current - 1) * perPage;
    var slice = viewCards.slice(start, start + perPage);

    grid.classList.add('is-fading');
    window.setTimeout(function () {
      grid.innerHTML = slice.length
        ? slice.join('')
        : '<li class="grid__item"><p class="cvf-no-results">No products match your filters.</p></li>';
      renderPager(current, totalPages);
      requestAnimationFrame(function () { grid.classList.remove('is-fading'); });
    }, 120);

    updateCount();
  }

  function els() {
    return {
      search: document.getElementById('cvf-search'),
      collection: document.getElementById('cvf-collection'),
      vendor: document.getElementById('cvf-vendor'),
      sort: document.getElementById('cvf-sort'),
      clear: document.getElementById('cvf-clear'),
      count: document.getElementById('cvf-count')
    };
  }

  function updateCount() {
    var c = els().count;
    if (c) c.textContent = viewCards.length + (viewCards.length === 1 ? ' product' : ' products');
  }

  function applyFilters() {
    var e = els();
    var q = e.search ? e.search.value.trim().toLowerCase() : '';
    var coll = e.collection ? e.collection.value : '';
    var vend = e.vendor ? e.vendor.value : '';
    var sort = e.sort ? e.sort.value : '';

    filtersActive = !!(q || coll || vend || sort);

    var rows = index.filter(function (p) {
      if (q && p.text.indexOf(q) === -1) return false;
      if (coll && p.collections.indexOf(coll) === -1) return false;
      if (vend && p.vendor !== vend) return false;
      return true;
    });

    if (sort) {
      rows = rows.slice().sort(function (a, b) {
        switch (sort) {
          case 'price-asc':  return a.price - b.price;
          case 'price-desc': return b.price - a.price;
          case 'title-asc':  return a.title.localeCompare(b.title);
          case 'title-desc': return b.title.localeCompare(a.title);
          default: return 0;
        }
      });
    }

    viewCards = rows.map(function (p) { return p.html; });

    if (filtersActive && window.location.pathname !== basePath) {
      history.replaceState({ page: 1 }, '', basePath);
    }

    paint(1);
  }

  function initControls() {
    var e = els();
    if (!e.search && !e.collection && !e.vendor && !e.sort) return;

    // Collection dropdown: only list collections that actually appear in the pool
    if (e.collection) {
      var present = {};
      index.forEach(function (p) {
        p.collections.forEach(function (h) { present[h] = true; });
      });
      Object.keys(present)
        .sort(function (a, b) {
          var la = collLabels[a] || a, lb = collLabels[b] || b;
          return la.localeCompare(lb);
        })
        .forEach(function (h) {
          if (basePath.endsWith('/' + h)) return; // skip current collection
          var o = document.createElement('option');
          o.value = h;
          o.textContent = collLabels[h] || h;
          e.collection.appendChild(o);
        });
    }

    // Brand dropdown from vendors in the pool
    if (e.vendor) {
      var vendors = {};
      index.forEach(function (p) { if (p.vendor) vendors[p.vendor] = true; });
      Object.keys(vendors).sort(function (a, b) { return a.localeCompare(b); }).forEach(function (v) {
        var o = document.createElement('option');
        o.value = v; o.textContent = v;
        e.vendor.appendChild(o);
      });
    }

    var t;
    if (e.search) e.search.addEventListener('input', function () {
      clearTimeout(t); t = setTimeout(applyFilters, 200);
    });
    [e.collection, e.vendor, e.sort].forEach(function (el) {
      if (el) el.addEventListener('change', applyFilters);
    });
    if (e.clear) e.clear.addEventListener('click', function () {
      if (e.search) e.search.value = '';
      if (e.collection) e.collection.value = '';
      if (e.vendor) e.vendor.value = '';
      if (e.sort) e.sort.value = '';
      applyFilters();
    });

    updateCount();
  }

  window.addEventListener('popstate', function () {
    if (!filtersActive) paint(getPageFromPath());
  });

  function fetchSectionPage(pg) {
    var url = basePath + '?section_id=' + encodeURIComponent(sectionId) + '&page=' + pg;
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid .grid__item');
        return Array.prototype.map.call(items, function (li) { return li.outerHTML; });
      });
  }

  (function collectAll() {
    showLoader();
    var pg = 1, done = false;
    function step() {
      return fetchSectionPage(pg).then(function (cards) {
        if (!cards.length) { done = true; }
        else {
          allCards = allCards.concat(cards);
          pg++;
          if (pg > 30) done = true;
        }
        if (!done) return step();
      });
    }
    step().then(function () {
      var seen = {}, unique = [];
      allCards.forEach(function (h) {
        var m = h.match(/\/products\/([a-z0-9\-]+)/i);
        var key = m ? m[1] : h.slice(0, 40);
        if (!seen[key]) { seen[key] = 1; unique.push(h); }
      });
      allCards = unique;

      buildIndex();
      viewCards = allCards;
      initControls();
      paint(getPageFromPath());
    })
    .catch(function (e) { console.error('[collection-visible-filter]', e); })
    .finally(function () { hideLoader(); });
  })();
})();